export enum PaymentType {
  FIAT = 'FIAT',
  COINS = 'COINS',
}
